export const main_routes = [
    {
        // path: '/:lang([a-z]{2})',
        path: '/',
        name: 'index',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "" } },
        // props: { data: { page: "Agenda", data: {depId: 1} } },
        meta: { requireAuth: true },
        // children: []
    },
    {
        path: '/pdf/:view/:id/:url',
        name: 'pdf_viewer_letter',
        component: () => import('@/layouts/Empty'),
        props: { data: { page: `views/PDFViewer` } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    // {
    //     path: '/pdf/:view/:url',
    //     name: 'pdf_viewer',
    //     component: () => import('@/layouts/Empty'),
    //     props: { data: { page: `views/PDFViewer` } },
    //     // meta: { requireAuth: true, requireAdmin: true },
    // },


    {
        path: '/notfoundf',
        name: 'notfound_full',
        component: () => import('@/layouts/Empty'),
        props: { data: { page: "pages/NotFound" } },
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('@/layouts/404'),
        props: { data: { page: "pages/NotFound" } },
    },
    {
        path: '/notperm',
        name: 'notperm',
        component: () => import('@/layouts/Empty'),
        props: { data: { page: "pages/NotPermission" } },
    },
    {
        path: '/:catchAll(.*)',
        name: '404',
        component: () => import('@/layouts/404'),
        props: { data: { page: "pages/NotFound" } },
        // component: () => import('@/layouts/404'),
        // props: { data: { page: "pages/NotFound" } },
    },
]
